import { type AssetSource, type AssetRole } from './asset';

export enum UploadDisposition {
    PENDING = "PENDING",
    COMPLETED = "COMPLETED",
    CANCELLED = "CANCELLED",
    ABANDONDED = "ABANDONED"
};

export type Upload = {
    id?: string,
    email: string,
    sessionId: string,
    source: AssetSource,
    role: AssetRole,
    disposition: UploadDisposition,
    filename: string,           // original filename
    url?: string,
    path?: string,
    mimeType: string,
    jumpId?: string,
    competitionId?: string
    timestamp?: string
};
